import React from "react";
import style from "./bar.module.css";

type BarPointProps = {
	id: string;
	x: number;
	y: number;
	height: number;
	isSelected: boolean;
	styles: {
		backgroundColor: string;
		backgroundSelectedColor: string;
		progressColor: string;
		progressSelectedColor: string;
		borderColor: string;
		borderWidth: number;
	};
};

export const BarPoint: React.FC<BarPointProps> = ({
	id,
	x,
	y,
	height,
	isSelected,
	styles,
}) => {
	const radius = Math.min(height / 1, 6); // Use half the height or 6px, whichever is smaller
	const centerY = y + height / 2;

	const getColor = () => {
		return isSelected ? styles.backgroundSelectedColor : styles.backgroundColor;
	};

	return (
		<g>
			<circle
				data-id={`id-${id}-point`}
				cx={x}
				cy={centerY}
				r={radius}
				fill={getColor()}
				className={style.barBackground}
				stroke={styles.borderColor}
				strokeWidth={Math.max(styles.borderWidth, 1)}
			/>
		</g>
	);
};
